import axios from "axios";
import { getBackendUrl } from "@/general";


export const dataProspectos = async (context, page, search, filters) => {
  const parameters = {
    ...filters,
    "page": page,
    "search": search
  }

  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/consultas/api/dataProspectos`,
      {
        params: parameters,
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch(err) {
    throw err.response;
  }
}

export const dataOportunidades = async (context, page, search, filters) => {
  const parameters = {
    ...filters,
    "page": page,
    "search": search
  }

  try {
    await context.$store.dispatch("statusLogin", context.$router);

    const { source } = await getBackendUrl();
    const res = await axios.get(
      `${source}/consultas/api/dataOportunidades`,
      {
        params: parameters,
        headers: {
          'Authorization': `Bearer ${context.$store.state.user.token}`
        }
      }
    );

    return res.data;
  } catch(err) {
    throw err.response;
  }
}
